import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Breadcrumb, Card, Form, Button } from "react-bootstrap";
import { createSingleOrganization } from "ServerAPI/serverAPI";
import Breadcrumbs from "components/elements/breadcrumbs/breadcrumbs";

const AddOrg = () => {
  // State to track the form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    address: "",
  });

  const navigate = useNavigate();

  // Handle form field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const submitHandler = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Collect form data
    const body = {
      ...formData,
      type: "organization",
    };
    const response = await createSingleOrganization(body);
    navigate("/organization/");
  };

  return (
    <Fragment>
      <Row>
        <Col lg={12} md={12} xs={12}>
          <div className="border-bottom pb-3 mb-3 ">
            <div className="mb-2 mb-lg-0">
              <h1 className="mb-0 h3 fw-bold"> + Add Organization </h1>
              <Breadcrumbs />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={{ offset: 3, span: 6 }} xs={12}>
          <Form onSubmit={submitHandler}>
            <Card className="mb-4">
              <Card.Body>
                <h4 className="mb-4">Organization Overview</h4>
                <Row className="gx-3">
                  <Form.Group as={Col} md={6} controlId="name" className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter Name"
                      required
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md={6}
                    controlId="email"
                    className="mb-3"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter Email address"
                      required
                    />
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    md={6}
                    controlId="phone"
                    className="mb-3"
                  >
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="number"
                      name="phoneNumber"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter Phone Number"
                      required
                    />
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>
            <Card className="mb-4">
              <Card.Body>
                <Row className="gx-3">
                  <Form.Group
                    as={Col}
                    md={12}
                    controlId="address"
                    className="mb-3"
                  >
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter Address"
                      required
                    />
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>

            <div className="d-flex justify-content-end">
              <Link
                to="/organization/"
                className="btn btn-outline-primary me-2"
              >
                Cancel
              </Link>
              <Button
                to="/organization/"
                variant="primary"
                type="submit"
                onClick={submitHandler}
              >
                Create
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AddOrg;
